const timeZones = [
  { label: "UTC (Coordinated Universal Time)", value: "UTC" },
  { label: "EST (Eastern Standard Time)", value: "America/New_York" }, // Default
  { label: "PST (Pacific Standard Time)", value: "America/Los_Angeles" },
  { label: "CST (Central Standard Time)", value: "America/Chicago" },
  { label: "MST (Mountain Standard Time)", value: "America/Denver" },
  { label: "GMT (Greenwich Mean Time)", value: "GMT" },
  { label: "CET (Central European Time)", value: "Europe/Berlin" },
  { label: "IST (Indian Standard Time)", value: "Asia/Kolkata" },
  { label: "JST (Japan Standard Time)", value: "Asia/Tokyo" },
  { label: "AEST (Australian Eastern Standard Time)", value: "Australia/Sydney" },
];

export default timeZones;
